import { render, staticRenderFns } from "./wechatBind.vue?vue&type=template&id=4c4a9678&"
import script from "./wechatBind.vue?vue&type=script&lang=js&"
export * from "./wechatBind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports